import { apiClient } from "../axiosConfig";

export type ContentStepContent = { html: string; css: string };
export type ContentElementContent = { html: string; css: string };

export const getContentStepContent = async (
  journeyId: string,
  stepId: string,
  version: string = "dev"
): Promise<ContentStepContent | null> => {
  const params = new URLSearchParams({ version });
  const response = await apiClient.get<ContentStepContent>(
    `/api/journeys/${journeyId}/content/step/${stepId}?${params.toString()}`,
    { validateStatus: (s) => s === 200 || s === 404 }
  );
  return response.status === 200 ? response.data : null;
};

export const getContentElementContent = async (
  journeyId: string,
  stepId: string,
  elementId: string,
  version: string = "dev"
): Promise<ContentElementContent | null> => {
  const params = new URLSearchParams({ version });
  const response = await apiClient.get<ContentElementContent>(
    `/api/journeys/${journeyId}/content/element/${stepId}/${elementId}?${params.toString()}`,
    { validateStatus: (s) => s === 200 || s === 404 }
  );
  return response.status === 200 ? response.data : null;
};
